import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { openWixStore, WIX_STORE_URL } from "@/lib/wixLinks";
import { IDS } from "@/constants/testIds";
import { ShoppingBag } from "lucide-react";

// Legacy /checkout/:productId route retained as a safety net for bookmarks and
// stale in-app links. On mount we open the Wix storefront in a new tab and
// send the user back to the Library — Stripe checkout is intentionally
// removed from the customer flow.
export default function Checkout() {
  const nav = useNavigate();

  useEffect(() => {
    openWixStore();
    // Small delay so users see the confirmation card before bouncing back.
    const t = setTimeout(() => nav("/library", { replace: true }), 1500);
    return () => clearTimeout(t);
  }, [nav]);

  return (
    <div className="max-w-md mx-auto text-center space-y-4" data-testid={IDS.checkoutPage}>
      <div className="inline-flex items-center justify-center w-14 h-14 rounded-full" style={{ background: "rgba(201,162,39,0.12)", border: "1px solid var(--pa-gold-dark)" }}>
        <ShoppingBag color="var(--pa-gold)" />
      </div>
      <h1 className="pa-serif text-2xl" style={{ color: "var(--pa-text-primary)" }}>Opening the store...</h1>
      <p className="text-sm" style={{ color: "var(--pa-text-secondary)" }}>
        Purchases happen on our Wix website. If a new tab did not open, click below.
      </p>
      <button className="pa-btn-gold" onClick={openWixStore} data-testid={IDS.checkoutPayBtn}>
        Open Store
      </button>
      <p className="text-xs" style={{ color: "var(--pa-text-muted)" }}>
        {WIX_STORE_URL}
      </p>
    </div>
  );
}
